import React from 'react';
import { AlertCircleIcon, RefreshCwIcon } from 'lucide-react';

import PageContainer from '@/components/layout/PageContainer';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface IProps {
  onRetry: () => void;
}

const ActingDetailsError: React.FC<IProps> = ({ onRetry }) => (
  <PageContainer title="Detalhes da Execução">
    <Alert variant="destructive">
      <AlertCircleIcon />
      <AlertTitle>Não foi possível carregar a execução</AlertTitle>
      <AlertDescription className="flex flex-col items-start gap-3">
        <p>Confira sua conexão e tente novamente.</p>
        <Button type="button" variant="outline" size="sm" onClick={onRetry}>
          <RefreshCwIcon className="size-4" />
          Tentar novamente
        </Button>
      </AlertDescription>
    </Alert>
  </PageContainer>
);

export default ActingDetailsError;
